import * as React from 'react';
import {Icon} from '../util';

interface AssetImportOptionProps {
	onImport(zipFile: File): void;
}

export default class AssetImportOption extends React.Component<AssetImportOptionProps, {}> {

	private inputInstance: HTMLInputElement;

	constructor(props: AssetImportOptionProps, context: any) {
		super(props, context);
		this.handleInputRef = this.handleInputRef.bind(this);
		this.handleClick = this.handleClick.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}

	public render() {
		return <a onClick={this.handleClick}>
			<Icon name='upload' /> Import configuration
			{this.renderInput()}
		</a>;
	}

	private renderInput() {
		return <input
			ref={this.handleInputRef}
			className='asset-import-input'
			type='file'
			accept='.zip'
			onChange={this.handleChange}
		/>;
	}

	private handleInputRef(instance: HTMLInputElement) {
		this.inputInstance = instance;
	}

	private handleClick() {
		this.inputInstance.click();
	}

	private handleChange(event: FormInputEvent) {
		const file = event.currentTarget.files[0];
		if (file) {
			this.props.onImport(file);
			event.currentTarget.value = '';
		}
	}

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/config-editor/AssetImportOption.tsx